module.exports = __webpack_public_path__ + "img/formSettings.f13ba562.svg";